export default "__VITE_ASSET__DG8DqiP7__"